import { render } from "./IconExclamationCircle.vue?vue&type=template&id=cabce004"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconExclamationCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cabce004"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cabce004', __exports__)) {
    api.reload('cabce004', __exports__)
  }
  
  module.hot.accept("./IconExclamationCircle.vue?vue&type=template&id=cabce004", () => {
    api.rerender('cabce004', render)
  })

}


export default __exports__